import React, { Component } from "react";
import { FloatActionButton, FloatActionButtonItem } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import AuthContext from "../../context/AuthContext";
import axiosConfig from "../../utils/axiosConfig";
import html2canvasInstance from "../../utils/html2canvasInstance";
import moment from "moment";

class PrintClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrint: false,
      logo: null,
      refs: null,
      imagesData: [], // Ajout d'un tableau pour stocker les images
    };
    this.dataPrint = {
      count: 0,
    };
    this.refHeader = React.createRef();
  }
  static contextType = AuthContext;

  getGroupIcon = () => {
    if (this.context.group) {
      let logo = localStorage.getItem("logoGroup");
      let group = localStorage.getItem("idGroup");
      if (!logo || parseInt(group) !== parseInt(this.context.group)) {
        axiosConfig("/auth/get-logo").then((res) => {
          if (res.data.success === true) {
            localStorage.setItem("logoGroup", res.data.data);
            localStorage.setItem("idGroup", this.context.group);
            this.setState({ logo: res.data.data });
          }
        });
      } else if (logo) {
        this.setState({ logo });
      }
    }
  };

  handlePrintClick = () => {
    this.setState({ isPrint: true }, () => {
      this.props.onPrint(true);
    });
  };

  // Nouvelle méthode pour télécharger une image individuelle
  downloadSingleImage = (dataUrl, index) => {
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${this.props.fileName || 'image'}_section_${index}_${moment().format("YYYYMMDDHHmmss")}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Nouvelle méthode pour télécharger toutes les images capturées
  downloadAllImages = () => {
    this.state.imagesData.forEach((dataUrl, index) => {
      setTimeout(() => {
        this.downloadSingleImage(dataUrl, index);
      }, index * 200); // Délai pour éviter les blocages de navigateur
    });
  };

  handleStartPrint = (close = false) => {
    this.dataPrint.count = 0;
    // Réinitialiser les images
    this.setState({ imagesData: [] });
    
    const max = this.state.refs && this.state.refs.length;
    this.state.refs &&
      this.state.refs.map((ref, idx) => {
        if (ref && ref.current) {
          // Appliquer le style d'impression pour éviter les coupures d'images
          ref.current.style = this.getWidthPrint();

          // Ajouter des styles pour éviter que les images ne soient coupées
          const images = ref.current.querySelectorAll("img");
          images.forEach((img) => {
            img.style.pageBreakInside = "avoid";
            img.style.breakInside = "avoid";
            img.style.display = "block";
            img.style.maxWidth = "100%";

            // Ajouter ces styles au conteneur parent de l'image
            if (img.parentElement) {
              img.parentElement.style.pageBreakInside = "avoid";
              img.parentElement.style.breakInside = "avoid";
            }
          });

          // Appliquer des styles aux conteneurs qui pourraient contenir des images
          const containers = ref.current.querySelectorAll(
            ".card, .col, .row, .container, section, article"
          );
          containers.forEach((container) => {
            container.style.pageBreakInside = "avoid";
            container.style.breakInside = "avoid";
          });
        }

        return setTimeout(() => {
          html2canvasInstance(ref.current, (result) => {
            if (result.success === true) {
              this.dataPrint[idx] = result.base64;
              
              // Stocker l'image dans le state pour téléchargement ultérieur
              this.setState(prevState => ({
                imagesData: [...prevState.imagesData, result.base64]
              }));
              
              this.checkPrint(max, close);
            }
          });
        }, 2000);
      });
  };

  checkPrint(max, close) {
    this.dataPrint.count++;
    if (this.dataPrint.count === max) {
      const data = {
        dataPrint: this.dataPrint,
        orientation: this.props.orientation
          ? this.props.orientation
          : "portrait",
        width: this.props.width ? this.props.width : "1500px",
      };
      if (close) {
        // En cas de fermeture, télécharger quand même les images
        // this.downloadAllImages();
      } else {
        axiosConfig("general/print", {
          data,
        }).then((res, err) => {
          this.state.refs.map((ref) => {
            if (ref.current) {
              return (ref.current.style.width = "auto");
            }
            return null;
          });
          this.setState({ isPrint: false }, () => {
            this.props.onPrint(false);
            if (res.data && res.data.success === true) {
              const link = document.createElement("a");
              link.href = res.data.file;
              link.download = `${this.props.fileName}_${moment().format(
                "YYYY-MM-DD"
              )}.pdf`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              
              // Télécharger toutes les images après avoir généré le PDF
              // this.downloadAllImages();
            }
          });
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.refs &&
      prevProps.refs !== this.props.refs &&
      this.state.isPrint &&
      this.refHeader &&
      this.props.refs.length > 0
    ) {
      let isNull = false;
      this.props.refs.map((ref) => {
        if (!ref.current) {
          isNull = true;
        }
        return true;
      });
      if (isNull === false) {
        this.setState({ refs: [this.refHeader, ...this.props.refs] }, () => {
          if (!this.state.refs[0].current && this.refHeader) {
            let refs = this.state.refs;
            refs[0] = this.refHeader;
            this.setState({ refs }, () => this.handleStartPrint());
          } else {
            this.handleStartPrint();
          }
        });
      }
    }
  }

  componentDidMount() {
    this.getGroupIcon();
  }

  getWidthPrint() {
    return `width: ${this.props.width}px; page-break-inside: avoid; break-inside: avoid;`;
  }

  render() {
    return (
      <div>
        {this.state.isPrint ? (
          <div
            ref={this.refHeader}
            style={{ pageBreakInside: "avoid", breakInside: "avoid" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pageBreakInside: "avoid",
                breakInside: "avoid",
              }}
            >
              <img
                alt={"logo"}
                style={{
                  maxHeight: "100px",
                  maxWidth: "100%",
                  pageBreakInside: "avoid",
                  breakInside: "avoid",
                  display: "block",
                }}
                src={this.state.logo}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  pageBreakInside: "avoid",
                  breakInside: "avoid",
                }}
              >
                <h3 style={{ fontSize: 28 }}>
                  {this.props.title.toUpperCase()}
                </h3>
                <p>{moment(new Date()).format("DD/MM/YYYY")}</p>
              </div>
            </div>
          </div>
        ) : null}
        {this.props.buttonItem ? (
          <FloatActionButtonItem
            text={"Télécharger"}
            icon={<FontAwesomeIcon icon={faPrint} />}
            onClick={() => this.handlePrintClick()}
          />
        ) : (
          <FloatActionButton
            icon={<FontAwesomeIcon icon={faPrint} />}
            onClick={() => this.handlePrintClick()}
          />
        )}
      </div>
    );
  }
}

export default PrintClass;
